import { ResultResponse } from '@/interfaces/api/models';
import Fetch from '@/utils/Fetch';

const getInvoice = async (id: any) => {
    let invoice = await Fetch.get({
        url: `/Invoice/${id}`
    } as any)
    return invoice
};

const markInvoiceStockAsUsed = async (id: any, toastCtx: any) => {
    let result = await Fetch.post({
        url: `/Invoice/MarkInvoiceStockAsUsed?invoiceID=${id}`,
        toastCtx: toastCtx
    });

    return result;
};

const compareJobInventory = async (invoice: any, invoiceItems: any, toastCtx: any) => {
    let result = await Fetch.post({
        url: `/Invoice/CompareJobInventory`,
        params: {
            Invoice: invoice,
            InvoiceItems: invoiceItems
        },
        toastCtx: toastCtx
    });

    return result;
}

export default {
    getInvoice,
    markInvoiceStockAsUsed,
    compareJobInventory
};
